import UUID from '@ax2/common/model/UUID';
import _ from 'lodash';

export const isNumberInRange = (
  value: number | null,
  min: number,
  max: number
): boolean => {
  return value != null && !isNaN(value) && value >= min && value <= max;
};

export const isIdInArray = (id: UUID | null, arr: UUID[]): boolean =>
  id != null && _.indexOf(arr, id) !== -1;
export const isArrayNotEmpty = (arr: UUID[]): boolean => arr.length > 0;

export const isArraySubset = (subset: UUID[], superset: UUID[]): boolean =>
  _.difference(subset, superset).length === 0;

export const isArraysEquals = (arr1: UUID[], arr2: UUID[]): boolean =>
  arr1.length === arr2.length && isArraySubset(_.uniq(arr1), _.uniq(arr2));

export const isCartesianSubset = (
  subset: { id1: UUID; id2: UUID }[],
  superset1: UUID[],
  superset2: UUID[]
): boolean => {
  return _.every(
    getCartesianProduct(superset1, superset2),
    c => _.findIndex(subset, s => s.id1 === c.id1 && s.id2 === c.id2) !== -1
  );
};

export const isArrayMinLength = (arr: UUID[], length: number): boolean =>
  arr.length >= length;

function getCartesianProduct(
  superset1: UUID[],
  superset2: UUID[]
): { id1: UUID; id2: UUID }[] {
  return _.flatten(
    _.map(superset1, id1 =>
      _.map(superset2, id2 => {
        return { id1, id2 };
      })
    )
  );
}
